import { AxiosError } from "axios";
import { $api } from "./interceptor";
import { toast } from "App";
import { TBaseTokenData } from "views/types/token";

type NotificationBody = {
  title: string;
  body: string;
  data?: { token: TBaseTokenData; url: string };
};

const NotificationsService = () => {
  const sendToAll = async ({
    title,
    message,
    token,
  }: {
    title: string;
    message: string;
    token?: TBaseTokenData;
  }) => {
    const requestData: NotificationBody = {
      title: title,
      body: message,
    };

    if (token) {
      requestData.data = {
        token,
        url: "MAIN",
      };
    }
    try {
      await $api.post("api/admins/send-notification-to-all ", requestData);
    } catch (e) {
      console.log("Error sending notifications", e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Error sending notifications",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    }
  };

  const sendTestToken = async ({
    title,
    message,
    token,
    userId,
  }: {
    title: string;
    message: string;
    token: TBaseTokenData;
    userId: number;
  }) => {
    const requestData = {
      usersIds: [userId],
      data: { title, body: message, data: { token, url: "MAIN" } },
    };

    try {
      await $api.post("api/admins/send-notification", requestData);
    } catch (e) {
      console.log("Error sending notifications", e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Error sending notifications",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    }
  };

  const getTokenInfo = async (tokenAddress: string) => {
    try {
      const { data } = await $api.get<TBaseTokenData>(
        `api/tokens/notification-token-data?address=${tokenAddress}`
      );

      return data;
    } catch (e) {
      console.log("Failed to load token info", e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Failed to load token info",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    }
  };

  const getMainUserId = async () => {
    try {
      const { data } = await $api.get<number>("api/admins/main-user-id");
      return data;
    } catch (e) {
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Failed to load user id for test notification",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      console.log(e);
      throw e;
    }
  };

  return {
    sendToAll,
    sendTestToken,
    getTokenInfo,
    getMainUserId,
  };
};

export const notificationsService = NotificationsService();
